import { Faq } from "./sections/Faq";
import Hero from "./sections/Hero";
import HowItWorks from "./sections/HowItWorks";

const AffiliateLandingPageView = () => {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Faq />
    </>
  );
};

export default AffiliateLandingPageView;
